import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const RegisterLayout = ({ children}) => (
  <Container fluid className="h-100 flower-bg">
    <Row className="h-100">
    <Row>
    <Col className="logotxt text-left pt-2 pb-2 logoheader ml-5 pl-5">
      <a href='/'><img src={`${process.env.PUBLIC_URL}/images/logo-blk.png`} alt="" className="img-fluid logo bg-mycolor" /></a>            
      </Col>
      </Row>
      <Col
        className="main-content p-0 h-100"
        lg={{ size: 12 }}
        md={{ size: 12 }}
        sm="12"
        tag="main"
      >
        {children}
      </Col>
    </Row>
  </Container>
);

export default RegisterLayout;